import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@material-ui/core';
import { Stack } from '@superdispatch/ui';
import { Button } from '@superdispatch/ui-lab';
import { WebViewLink } from 'shared/routing/WebViewLinks';

interface LoadboardNonVerifiableDialogProps {
  open: boolean;
  onClose: () => void;
}

export function LoadboardNonVerifiableDialog({
  open,
  onClose,
}: LoadboardNonVerifiableDialogProps) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Your access to Super Loadboard is limited</DialogTitle>

      <DialogContent>
        <Stack space="small">
          <Typography>
            Super Dispatch can only verify Auto Haulers, Towaway and Driveaway
            carriers based in the U.S. You can continue to book loads from the
            Super Loadboard for shippers who have approved you to request or
            instantly book.
          </Typography>
          <WebViewLink
            target="_blank"
            rel="noreferrer noopener"
            href="https://support.superdispatch.com/hc/articles/35661834835859-Why-can-t-my-documents-be-verified"
          >
            Learn More
          </WebViewLink>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Got it</Button>
      </DialogActions>
    </Dialog>
  );
}
